import { render } from "./PaymentIconList.vue?vue&type=template&id=00c24981&scoped=true"
import script from "./PaymentIconList.vue?vue&type=script&lang=js"
export * from "./PaymentIconList.vue?vue&type=script&lang=js"

import "./PaymentIconList.vue?vue&type=style&index=0&id=00c24981&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00c24981"]])

export default __exports__